module.exports = __webpack_public_path__ + "media/matisse.49d862ba.webm";